import Vue from "vue";
import ExternalFacingView from "../components/shared/ExternalFacingView.vue";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "../components/Login/Login.vue";
import Fail from "../components/Fail.vue";
import Success from "../components/Success.vue";
import Meta from "vue-meta";

Vue.use(VueRouter);
Vue.use(Meta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  ssrAttribute: "data-vue-meta-ssr",
  tagIDKeyName: "vmid",
});

const routes: Array<RouteConfig> = [
  {
    path: "*",
    name: "Not Found",
    redirect: () => "/not-found",
  },
  {
    path: "/",
    component: ExternalFacingView,
    children: [
      {
        path: "",
        redirect: () => ({ name: "Login" }),
      },
      {
        path: "",
        name: "Login",
        component: () => import("@/components/Login/Login.vue"),
      },
      {
        path: "fail",
        name: "Fail",
        component: Fail,
      },
      {
        path: "success",
        name: "Success",
        component: Success,
      },
    ],
  },
  //
  {
    path: "*",
    name: "catchAll",
    component: Login,
  },
];
const router = new VueRouter({
  routes,
  mode: "history",
});

export default router;
